export const APPLICANT = 'applicant';
export const BACKGROUND = 'background';
export const CREDIT = 'credit';
